import * as React from "react";
import Typography from "@mui/material/Typography";
import { SxProps } from "@mui/system";

import {
  EmphasisType,
  ShadeType,
  CategoryType,
  Variant,
  FontWeightProperty,
} from "./types";
import { TEXT_COLOR_MAPPING } from "../../../constants";

export interface CustomTypographyProps {
  /** "high" | "medium_high"  | "medium" | "medium_low"  | "disabled". */
  emphasis?: EmphasisType;
  /** "dark"    | "light"     | "say" */
  shade?: ShadeType;
  /** "primary" | "onsurface" | "error" */
  category?: CategoryType;
  /** number    | string */
  weight?: FontWeightProperty;
  children?: React.ReactNode;
  /** from material_ui */
  variant?: Variant;
  /** sx prop */
  sx?: SxProps;
  /** component variation */
  component?: React.ElementType;
  family?: "primary" | "secondary";
}

const Text = ({
  children,
  emphasis = "high",
  shade = "dark",
  category = "primary",
  weight,
  family = "primary",
  sx = {},
  ...rest
}: CustomTypographyProps): JSX.Element => {
  return (
    <Typography
      sx={{
        ...TEXT_COLOR_MAPPING[`${category}-${shade}-${emphasis}`],
        ...sx,
      }}
      style={{
        ...(weight && { fontWeight: weight }),
        ...(family === "secondary" && { fontFamily: "Matter" }),
      }}
      {...rest}
    >
      {children}
    </Typography>
  );
};

export default Text;
